import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useI18N } from '../../hooks/useI18n'
import { useSurveyState } from '../../hooks/useSurveyState'

// Encode the current URL as a base64 string same way website does it
const marketingSource = btoa(
  JSON.stringify({
    referrer: window.location.href,
    utm_source: 'trustmary-survey',
    utm_medium: 'survey-bottom-banner-link',
    utm_campaign: 'loop',
  })
)
const registerUrl = `https://app.trustmary.com/register?s=${marketingSource}`

function CampaignFooterBanner() {
  const { t } = useI18N()
  return (
    <Stack
      sx={{
        py: 3,
        px: 3,
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 2,
        gap: 3,
        alignItems: 'center',
      }}>
      <Stack gap={1} alignItems="center">
        <Typography variant="subtitle1">
          {t('footer.banner.title')}{' '}
          <Typography
            component="span"
            sx={{
              display: 'inline-block',
              textTransform: 'lowercase',
              fontWeight: '700',
              backgroundImage: `url('https://d2nce6johdc51d.cloudfront.net/source/trustmary.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0 50%',
              backgroundSize: '10px 18px',
              paddingLeft: '13px',
              color: '#0d3b70',
              marginLeft: '2px',
            }}>
            Trustmary
          </Typography>
        </Typography>
        <Typography variant="body1">{t('footer.banner.description')}</Typography>
      </Stack>
      <Button variant="contained" size="large" color="primary" component="a" href={registerUrl}>
        {t('footer.banner.cta')}
      </Button>
    </Stack>
  )
}

export function CampaignFooter() {
  const [state] = useSurveyState()
  const { t } = useI18N()
  if (!('meta' in state)) return null

  const surveyType = state.meta.surveyType || 'feedback'
  const isThanksPage = !!state.thanksPage?.thanks

  // Show banner on thanks page
  if (isThanksPage) return <CampaignFooterBanner />

  return (
    <Stack
      sx={{
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        p: {
          xs: 2,
          sm: 0,
        },
        mb: 2,
      }}>
      <Box
        sx={{
          bgcolor: '#ffffff',
          borderRadius: 1,
          px: 1.5,
          py: 1,
          boxShadow: theme => theme.customShadows.z4,
        }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
            fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
sans-serif`,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            a: {
              color: 'text.primary',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            },
          }}>
          <a href={t(`footer.poweredByLinkUrl.${surveyType}`)} target="_blank" rel="noreferrer">
            {t(`footer.poweredByLinkText.${surveyType}`)}
          </a>
          {' by '}
          <Typography
            component="span"
            sx={{
              display: 'inline-block',
              textTransform: 'lowercase',
              fontWeight: '700',
              backgroundImage: `url('https://d2nce6johdc51d.cloudfront.net/source/trustmary.svg')`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0 50%',
              backgroundSize: '10px 18px',
              paddingLeft: '13px',
              color: '#0d3b70',
              marginLeft: '2px',
            }}>
            Trustmary
          </Typography>
        </Typography>
      </Box>
    </Stack>
  )
}
